(function () {
  var SELECTOR = "[data-qk-delivery-estimate]";
  var TIME_ZONE = "Europe/Bucharest";
  var CUTOFF_HOUR = 15;
  var CUTOFF_MINUTE = 30;
  var refreshTimer = null;

  var bucharestFormatter = new Intl.DateTimeFormat("en-CA", {
    timeZone: TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  });

  var fullDateFormatter = new Intl.DateTimeFormat("ro-RO", {
    timeZone: "UTC",
    weekday: "long",
    day: "numeric",
    month: "long",
  });

  function getBucharestParts(date) {
    var values = {};

    bucharestFormatter.formatToParts(date).forEach(function (part) {
      if (part.type !== "literal") {
        values[part.type] = Number(part.value);
      }
    });

    return values;
  }

  function toUtcDate(parts) {
    return new Date(Date.UTC(parts.year, parts.month - 1, parts.day, 12));
  }

  function addCalendarDay(date) {
    var nextDate = new Date(date.getTime());
    nextDate.setUTCDate(nextDate.getUTCDate() + 1);
    return nextDate;
  }

  function addBusinessDays(date, amount) {
    var result = new Date(date.getTime());
    var remaining = amount;

    while (remaining > 0) {
      result = addCalendarDay(result);

      if (result.getUTCDay() !== 0 && result.getUTCDay() !== 6) {
        remaining -= 1;
      }
    }

    return result;
  }

  function capitalize(value) {
    return value.charAt(0).toLocaleUpperCase("ro-RO") + value.slice(1);
  }

  function formatDate(date, tomorrow) {
    if (date.getTime() === tomorrow.getTime()) {
      return "Mâine";
    }

    return capitalize(fullDateFormatter.format(date));
  }

  function getEstimate(now) {
    var parts = getBucharestParts(now);
    var today = toUtcDate(parts);
    var tomorrow = addCalendarDay(today);
    var weekday = today.getUTCDay();
    // Weekend orders share the Monday-Tuesday window for both delivery methods.
    if (weekday === 0 || weekday === 6) {
      return {
        fast: "Luni - Marți",
        standard: "Luni - Marți",
        speedLabel: "Livrare rapidă · 1 zi lucrătoare",
      };
    }

    var minuteOfDay = parts.hour * 60 + parts.minute;
    var cutoffAtMinute = CUTOFF_HOUR * 60 + CUTOFF_MINUTE;
    var beforeCutoff = minuteOfDay < cutoffAtMinute;
    var fastBusinessDays;
    var speedLabel;

    if (weekday >= 1 && weekday <= 4) {
      fastBusinessDays = beforeCutoff ? 1 : 2;
      speedLabel = beforeCutoff ? "Livrare rapidă · de regulă în 24h" : "Livrare rapidă · 1 zi lucrătoare";
    } else if (weekday === 5) {
      fastBusinessDays = beforeCutoff ? 1 : 2;
      speedLabel = "Livrare rapidă · 1 zi lucrătoare";
    }

    var fastDate = addBusinessDays(today, fastBusinessDays);
    var standardEndDate = addBusinessDays(fastDate, 1);

    return {
      fast: formatDate(fastDate, tomorrow),
      standard: formatDate(fastDate, tomorrow) + " – " + formatDate(standardEndDate, tomorrow),
      speedLabel: speedLabel,
    };
  }

  function updateEstimate(element, estimate) {
    var speed = element.querySelector("[data-qk-delivery-speed]");
    var fast = element.querySelector("[data-qk-delivery-fast]");
    var fastDetail = element.querySelector("[data-qk-delivery-fast-detail]");
    var standard = element.querySelector("[data-qk-delivery-standard]");

    if (speed) speed.textContent = estimate.speedLabel;
    if (fast) fast.textContent = estimate.fast;
    if (fastDetail) fastDetail.textContent = estimate.fast;
    if (standard) standard.textContent = estimate.standard;
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var elements = scope.querySelectorAll(SELECTOR);
    var estimate = getEstimate(new Date());

    for (var index = 0; index < elements.length; index += 1) {
      updateEstimate(elements[index], estimate);
    }
  }

  function scheduleMinuteRefresh() {
    if (refreshTimer !== null) {
      window.clearTimeout(refreshTimer);
    }

    var delay = 60000 - (Date.now() % 60000) + 50;

    refreshTimer = window.setTimeout(function refresh() {
      init(document);
      scheduleMinuteRefresh();
    }, delay);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
      scheduleMinuteRefresh();
    });
  } else {
    init(document);
    scheduleMinuteRefresh();
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
